module.exports = __webpack_public_path__ + "media/zips/Transparent_BLK_WS_White_Logo-f4bab5d04bcc0847980f5f6256264521.zip";